//external dependencies
import 'jquery';
import 'bootstrap';

//duplicate navigation for sticky navigation
$('#normal-navigation').clone().attr("id", "sticky-navigation").insertAfter('#normal-navigation');

//mobile menu open/close, change menu icon to X when open
$(".mobile-menu-icon").click(function () {
  if ($(".mobile-menu-icon").hasClass("active")) {
    $(".mobile-menu-icon img").attr("src", "/wp-content/themes/base/resources/assets/images/default-theme-mobile-menu-icon.png");
  } else {
    $(".mobile-menu-icon img").attr("src", "/wp-content/themes/base/resources/assets/images/default-mobile-close-icon.png");
  }
  $(".mobile-menu-icon").toggleClass("active");
  $("#mobile-menu-expand").toggleClass("active");
  $("body").toggleClass("active");
});

//desktop menu open/close, change menu icon to X when open
$(".desktop-menu-button").click(function () {
  if ($(".desktop-menu-button").hasClass("active")) {
    $(".desktop-menu-button img").attr("src", "/wp-content/themes/base/resources/assets/images/menu-icon.svg");
    $(".desktop-menu-button span").text("MENU");
  } else {
    $(".desktop-menu-button img").attr("src", "/wp-content/themes/base/resources/assets/images/close.svg");
    $(".desktop-menu-button span").text("CLOSE");
    //$(".desktop-full-nav .menu > li.menu-item-has-children:first-child > a").click();
    $(".desktop-full-nav .menu > li.current-menu-parent:not(.parents-last-link), .desktop-full-nav .menu > li.current-menu-ancestor:not(.parents-last-link), .desktop-full-nav .menu > li.current-menu-ancestor li.current-menu-parent:not(.parents-last-link)").addClass("active");
  }
  $(".desktop-menu-button").toggleClass("active");
  $(".desktop-full-screen").toggleClass("active");
  $(".secondary-navigation li").removeClass("active");
  $(".secondary-navigation + .overlay").hide();
  $("body").toggleClass("active");
});

var body = document.getElementById('sticky-navigation');
var headerHeight = body.offsetHeight;
var scrollUp = "floater";
var scrollDown = "static";
var lastScroll = 0;
window.addEventListener("scroll", function () {
  var currentScroll = window.pageYOffset;
  if (currentScroll <= headerHeight + 50) {
    body.classList.remove(scrollUp);
    body.style.position = "fixed";
    body.style.transform = 'translateY(-150px)';
    return;
  }
  if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
    // down
    body.classList.remove(scrollUp);
    body.classList.add(scrollDown);
    body.style.position = "fixed";
    body.style.transform = 'translateY(-150px)';
  } else if (currentScroll < lastScroll && body.classList.contains(scrollDown)) {
    // up
    body.classList.remove(scrollDown);
    body.classList.add(scrollUp);
    body.style.transform = 'translateY(0px)';
    body.style.position = "fixed";
  }

  lastScroll = currentScroll;
});

//mobile menu sub menu toggle
$(".secondary-navigation li.menu-item-has-children").click(function() {
  if ($(this).hasClass("active")) {
    $(this).removeClass("active");
    $(".secondary-navigation + .overlay").hide();
  } else {
    $(".secondary-navigation li.menu-item-has-children.active").removeClass("active");
    $(this).addClass("active");
    $(".secondary-navigation + .overlay").show();
    $(".secondary-navigation + .overlay").click(function () {
      $(".secondary-navigation li").removeClass("active");
      $(".secondary-navigation + .overlay").hide();
    });
  }
  $(document).keyup(function(e) {
    if (e.key === "Escape") { // escape key maps to keycode `27`
      $(".secondary-navigation li").removeClass("active");
      $(".secondary-navigation + .overlay").hide();
    }
  });
});

// //desktop menu sub menu toggle
// $(".desktop_navigation li.menu-item-has-children > a").click(function() {
//   if ($(this).parent().hasClass("active")) {
//     $(this).parent().removeClass("active");
//     $(this).parent().parent().removeClass("child-active");
//   } else {
//     $(".desktop_navigation li.menu-item-has-children.active > a").parent().removeClass("active");
//     $(this).parent().addClass("active");
//     $(this).parent().parent().addClass("child-active");
//   }
// });

//desktop menu sub menu toggle (main h2 looking)
$(".desktop-full-nav li.menu-item-has-children > a").click(function() {
  if ($(this).parent().hasClass("active")) {
    $(this).parent().removeClass("active");
  } else {
    $(this).parent().siblings("li.menu-item-has-children").removeClass("active");
    $(this).parent().addClass("active");
  }
});

//smooth scroll
document.querySelectorAll('a[href^="#"]:not([href*="#main-content"])').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
      e.preventDefault();
      try {
        document.querySelector(this.getAttribute('href')).scrollIntoView({
            behavior: 'smooth'
        });
      } catch (er) { }
  });
});

//notification banner
$(document).ready(function() {
    if(getCookie('show_cookie_message') != 'no') {
      $('.notification-banner').show();
      $('.notification-banner').addClass("active");
    } else {
      $('.notification-banner').hide();
      $('.notification-banner').removeClass("active");
    }
    $('.cookie_box_close').click(function() {
      $(".notification-banner").fadeOut(300, function() { $(this).remove(); });
      setCookie('show_cookie_message','no');
      $('.notification-banner').removeClass("active");
      return false;
    });
    $("#navigator-am").on('change', function() {
      if ($(this).val() == "A Maumee Valley Parent or Guardian") {
        $(".navigator-want").hide().removeClass("active");
        $("#navigator-want1").show().addClass("active");
      } else if ($(this).val() == "A Maumee Valley Alumni") {
        $(".navigator-want").hide().removeClass("active");
        $("#navigator-want2").show().addClass("active");
      } else if ($(this).val() == "Interested in attending Maumee Valley") {
        $(".navigator-want").hide().removeClass("active");
        $("#navigator-want3").show().addClass("active");
      } else if ($(this).val() == "A Prospective MV teacher") {
        $(".navigator-want").hide().removeClass("active");
        $("#navigator-want4").show().addClass("active");
      }
    });
    $("#navigator-submit").click(function() {
      if ($(".navigator-want.active").val() == "https://sideline.bsnsports.com/schools/ohio/toledo/maumee-valley-country-day-school" || $(".navigator-want.active").val() == "https://mvcdsconnect.com/") {
        window.open(($(".navigator-want.active").val()), '_blank').focus();
      } else {
        window.open(($(".navigator-want.active").val()), '_self').focus();
      }
    });
});
function setCookie(cookie_name, value) {
  var exdate = new Date();
  exdate.setDate(exdate.getDate() + (365*25));
  document.cookie = cookie_name + "=" + escape(value) + "; expires="+exdate.toUTCString() + "; path=/";
}
function getCookie(cookie_name) {
    if (document.cookie.length>0) {
      var cookie_start = document.cookie.indexOf(cookie_name + "=");
      var cookie_end;
      if (cookie_start != -1) {
        cookie_start = cookie_start + cookie_name.length+1;
        cookie_end = document.cookie.indexOf(";",cookie_start);
        if (cookie_end == -1) {
            cookie_end = document.cookie.length;
        }
        return unescape(document.cookie.substring(cookie_start,cookie_end));
      }
    }
    return "";
}

try {
  $(".tribe-filter-bar-c-filter--multiselect").addClass("tribe-filter-bar-c-filter--open");
} catch (e) {

}

try {
  if ($(".tribe-events-c-messages__message-list-item").text().includes("There were no results found")) {
    $(".tribe-events-c-messages__message-list-item").text("No events currently scheduled. Check back later to see if we've added any!")
  }
} catch (e) {

}


jQuery(function ($) {
  $(document).ready(function ()
  {
      var wpcf7Elm = document.querySelector( '.wpcf7' );
      wpcf7Elm.addEventListener( 'wpcf7submit', function( event ) {
          setTimeout(function() {
              $([document.documentElement, document.body]).animate({
                  scrollTop: $(".wpcf7-response-output").offset().top - 100
              }, 500);
          }, 500);
          //console.log("Submited");
      }, false );
  });
});



console.log("A website made by https://metricmarketing.ca/");